import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import { Button, Modal, Table, Result } from "antd";
import {
  EditOutlined,
  UploadOutlined,
  PlaySquareOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";

import Moment from "moment";
import "moment-timezone";
import { extendMoment } from "moment-range";

import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { chain, orderBy } from "lodash";

import { getPipeSchedule } from "../../libs/utils";

import { getRobotWeld, getRobotTier } from "./robotSlice";

import RobotWeldTestReportForm from "./RobotWeldTestReportForm";
import LoadingPage from "../../components/LoadingPage";
const moment = extendMoment(Moment);

const columns = [
  { title: "" },
  {
    title: "Date",
    render: (_, item) => {
      if (item.children) {
        return <span>{moment(item.arc_off_utc).format("YYYY-MM-DD")}</span>;
      } else {
        return <span>{moment(item.arc_on_utc).format("YYYY-MM-DD")}</span>;
      }
    },
  },
  {
    title: "Order",
    dataIndex: "work_order_ref",
    // filters: weldRunFilters("work_order_ref"),
    // onFilter: (value, record) => record.work_order_ref.indexOf(value) === 0,
  },
  {
    title: "Spool",
    dataIndex: "spool_ref",
    // filters: weldRunFilters("spool_ref"),
    // onFilter: (value, record) => record.spool_ref.indexOf(value) === 0,
  },
  {
    title: "Welder ID",
    dataIndex: "welder_id_ref",
    // filters: weldRunFilters("welder_id_ref"),
    onFilter: (value, record) =>
      record.welder_id_ref && record.welder_id_ref.indexOf(value) === 0,
  },
  {
    title: "Run",
    dataIndex: "run_number", // should have count
  },
  {
    title: "Start Time",
    render: (_, item) => {
      return <span>{moment(item.arc_on_utc).format("HH:mm:ss")}</span>;
    },
  },
  {
    title: "Arc Off Time",
    render: (_, item) => {
      if (item.duration) {
        return (
          <span>
            {Number(item.duration.hours()) * 60 +
              Number(item.duration.minutes()) +
              "m "}
            {item.duration.seconds() + "s"}
          </span>
        );
      } else {
        return <span>{null}</span>;
      }
    },
  },
  {
    title: "Weld Time",
    render: (_, item) => {
      return (
        <span>
          {Number(moment.duration({ ...item.weld_time }).hours()) * 60 +
            Number(moment.duration({ ...item.weld_time }).minutes()) +
            "m "}
          {moment.duration({ ...item.weld_time }).seconds() + "s"}
        </span>
      );
    },
  },
  {
    title: "Pipe Size",
    // filters: weldRun
    //   .filter((item) =>
    //     moment(item.arc_on_utc).isSameOrAfter(
    //       filterData
    //         .find(({ key }) => key === dropdownKey)
    //         .date.format("YYYY-MM-DD")
    //     )
    //   )
    //   .map((item) => {
    //     const unit =
    //       !item.units_system || item.units_system === "imperial" ? "in" : "cm";
    //     return `${item.pipe_size_inches}${unit}`;
    //   })
    //   .filter((value, index, self) => self.indexOf(value) === index)
    //   .map((item) => {
    //     return { text: item, value: item };
    //   }),
    // onFilter: (value, record) => {
    //   const unit =
    //     !record.units_system || record.units_system === "imperial"
    //       ? "in"
    //       : "cm";
    //   return `${record.pipe_size_inches}${unit}` === value;
    // },
    render: (_, item) => {
      const unit =
        !item.units_system || item.units_system === "imperial" ? "in" : "cm";
      return <span>{`${item.pipe_size_inches}${unit}`}</span>;
    },
  },
  {
    title: "Pipe Sched",
    // filters: weldRun
    //   .filter((item) =>
    //     moment(item.arc_on_utc).isSameOrAfter(
    //       filterData
    //         .find(({ key }) => key === dropdownKey)
    //         .date.format("YYYY-MM-DD")
    //     )
    //   )
    //   .map((item) => {
    //     return getPipeSchedule(item.pipe_schedule);
    //   })
    //   .filter((value, index, self) => self.indexOf(value) === index)
    //   .map((item) => {
    //     return { text: item, value: item };
    //   }),
    // onFilter: (value, record) => {
    //   return record.pipe_schedule === value;
    // },
    render: (_, item) => {
      return <span>{getPipeSchedule(item.pipe_schedule)}</span>;
    },
  },
  {
    title: "FDI",
    render: (_, item) => {
      if (!item.run_number) {
        return <span>{item.weld_inches}</span>;
      } else {
        return <span></span>;
      }
    },
  },
  {
    title: "Operator",
    dataIndex: "operator_name",
    // filters: weldRunFilters("operator_name"),
    onFilter: (value, record) => {
      if (record.children && record.children.length > 0) {
        return record.children
          .map((child) => child.operator_name.indexOf(value) === 0)
          .filter((c) => c);
      } else {
        return (
          record.operator_name && record.operator_name.indexOf(value) === 0
        );
      }
    },
  },
  {
    title: "X-Ray",
    dataIndex: "x_ray",
  },
  {
    title: "Action",
    render: () => (
      <>
        <Button
          icon={<EditOutlined />}
          //   disabled={editingKey !== ""}
          //   onClick={() => edit(record)}
        />
        <Button
          icon={<UploadOutlined />}
          //   disabled={editingKey !== ""}
          //   onClick={() => edit(record)}
        />
        <Button
          icon={<PlaySquareOutlined />}
          //   disabled={editingKey !== ""}
          //   onClick={() => edit(record)}
        />
        <Button
          icon={<FileExcelOutlined />}
          //   disabled={editingKey !== ""}
          //   onClick={() => edit(record)}
        />
      </>
    ),
  },
];

function RobotWeldResults() {
  const weld_run = useSelector((state) => state.robot.weldRun);

  return (
    <>
      <Table
        dataSource={weld_run.map((item) => {
          const idx = weld_run.findIndex((i) => i === item);
          if (
            idx < weld_run.length - 1 &&
            moment(weld_run[idx + 1].arc_on_utc, "YYYY-MM-DD").diff(
              moment(item.arc_on_utc, "YYYY-MM-DD"),
              "days"
            ) === 0
          ) {
            const duration = moment.duration(
              moment(item.arc_on_utc).diff(
                moment(weld_run[idx + 1].arc_off_utc)
              )
            );

            return { ...item, duration };
          } else {
            return { ...item };
          }
        })}
        columns={columns}
      ></Table>
      {/* RobotWeldResults: {JSON.stringify(data)} */}
    </>
  );
}

// export default RobotWeldResults;

function RobotWeldTestReportsCalendar(props) {
  const calendarRef = useRef(null);

  const dispatch = useDispatch();

  const weld_run = useSelector((state) => state.robot.weldRun);
  const tier = useSelector((state) => state.robot.tier);
  const { robotName } = useParams();
  const history = useHistory();
  const robotId =
    robotName && robotName.match(/(\d+)/) && robotName.match(/(\d+)/)[0];

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    dispatch(getRobotWeld(robotId));
    dispatch(getRobotTier(robotId));
  }, [dispatch]);

  if (!(weld_run && weld_run[robotId])) {
    return <div></div>;
  }
  if (!tier) {
    return <LoadingPage />;
  }

  if (props.isCustomer && tier[robotId].tier === "lite") {
    return (
      <Result
        title="This feature is available in Essential Plan"
        subTitle="Please contact customer support for inquiry."
        extra={
          <Button
            onClick={() => {
              history.goBack();
            }}
            type="primary"
          >
            Back
          </Button>
        }
      />
    );
  }

  const weldRun = weld_run[robotId];

  const groupedWeldRun = chain(weldRun)
    .map((item) => {
      const idx = weldRun.findIndex((i) => i === item);
      if (
        idx < weldRun.length - 1 &&
        moment(weldRun[idx + 1].arc_on_utc, "YYYY-MM-DD").diff(
          moment(item.arc_on_utc, "YYYY-MM-DD"),
          "days"
        ) === 0
      ) {
        const duration = moment.duration(
          moment(item.arc_on_utc).diff(moment(weldRun[idx + 1].arc_off_utc))
        );

        return { ...item, duration };
      } else {
        return { ...item };
      }
    })
    .groupBy((item) => {
      return item.work_order_ref + " " + item.spool_ref;
    })
    .entries()
    .map(([work_order_spool, weld]) => {
      const children = orderBy(
        [...weld],
        [
          (i) => {
            return i.run_number;
          },
        ],
        ["desc"]
      );

      const childrenSize = children.length;
      const first = children[0];
      const last = children[childrenSize - 1];

      return {
        key: work_order_spool,
        children,
        title: work_order_spool,
        start: moment(last.arc_off_utc).utc(true).format(),
        end: moment(first.arc_off_utc).utc(true).format(),
        work_order_ref: last.work_order_ref,
        spool_ref: last.spool_ref,
        welder_id_ref: last.welder_id_ref,

        units_system: last.units_system,
        pipe_size_inches: last.pipe_size_inches,
        pipe_schedule: last.pipe_schedule,

        // sum of arc off time (setup time) on grouped weld
        duration: children.slice(1).reduce((prev, curr) => {
          return prev.add(curr.duration);
        }, moment.duration(first.duration)),

        // sum of weld time on grouped weld
        weld_time: children.slice(1).reduce((prev, curr) => {
          return prev.add(curr.weld_time);
        }, moment.duration(first.weld_time))._data,

        weld_inches: last.run_number === 0 ? last.weld_inches : null,
      };
    })
    .value();

  return (
    <>
      <FullCalendar
        ref={calendarRef}
        headerToolbar={{
          left: "prevYear,prev,today,next,nextYear",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        height={"90%"}
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
        initialView="dayGridMonth"
        events={groupedWeldRun}
        eventClick={(info) => {
          setSelectedJob({
            start: info.event.start,
            end: info.event.end,
            ...info.event.extendedProps,
          });

          setModalOpen(true);
        }}
        navLinks={false}
        navLinkDayClick={(date, jsEvent) => {}}
      />

      {!!selectedJob && (
        <Modal
          className="WeldTestReport_Modal"
          title={`Weld Test Report of ${selectedJob.work_order_ref} ${selectedJob.spool_ref} ${selectedJob.welder_id_ref}`}
          visible={modalOpen}
          // onOk={handleOk}
          onCancel={() => setModalOpen(false)}
          footer={null}
          width={800}
          style={{ width: "80vw" }}
          destroyOnClose={true}
        >
          <RobotWeldTestReportForm job={selectedJob}></RobotWeldTestReportForm>
        </Modal>
      )}
    </>
  );
}

export default RobotWeldTestReportsCalendar;
